[
  {
    "code": "UG-C",
    "name": "Central"
  },
  {
    "code": "UG-E",
    "name": "Eastern"
  },
  {
    "code": "UG-N",
    "name": "Northern"
  },
  {
    "code": "UG-W",
    "name": "Western"
  }
]